import React from 'react';
import { Route, Switch } from 'react-router-dom';
import InformationPanel from '../../InformationPanel/page/view';
import Admin from '../../security/page/admin';
import AdminHistory from '../../security/page/history';
import HistoryEvent from '../../security/page/event';
import Support from '../../support/page/list';
import GroupsCashiers from '../../cashiers/page/groups';
import Finance from '../../cashiers/page/finance';
import ShiftList from '../../cashiers/page/shift';
import CashiersList from '../../cashiers/page/cashiers';
import KycList from '../../kyc/page/list';
import Gamer from '../../gamer/page/list';
import GamerView from '../../gamer/page/view';
import Replenishment from '../../replenishment/page/gamer';
import Payment from '../../replenishment/page/payment';
import Withdrawals from '../../withdrawals/page/list';
import Operation from '../../withdrawals/page/operation';
import PaymentList from '../../payment/page/list';
import HistoryCredit from '../../credit/page/history';
import GamesSearch from '../../games/page/search';
import Report from '../../games/page/report';
import Line from '../../credit/page/line';
import ReportFinance from '../../report/page/finance';
import ReportEvent from '../../report/page/event';
import ReportJackpot from '../../report/page/jackpot';
import ReportBonuses from '../../report/page/bonuses';
import ReportBalance from '../../report/page/balance';
import JackpotList from '../../jackpot/page/list';
import ViewSupport from '../../support/page/view';
import ReportGames from '../../gamer/page/reportGames';
import Events from '../../gamer/page/events';
import Deposit from '../../gamer/page/deposit';
import WithdrawalsGamer from '../../gamer/page/withdrawals';
import Bonuses from '../../gamer/page/bonuses';
import Jackpot from '../../gamer/page/jackpot';
import View from '../../cashiers/page/view';
import { useSelector } from 'react-redux';
import { Allow as AllowMap } from '../../../settings/allow';
import Statistics from '../../statistics/page/view';
import MailingList from '../../mailing/page/list';
import MailingView from '../../mailing/page/view';

const Routes = () => {
    const view = useSelector(state => state.auth.admin);
    const Allow = AllowMap()
    return (
        <Switch>
            {/* Информационная панель */}
            {view?.allow?.includes(Allow.InformationPanel.allow) && <Route exact path="/" component={InformationPanel} />}
            {view?.allow?.includes(Allow.Mailing.allow) && <Route exact path="/statistics" component={Statistics} />}
            {view?.allow?.includes(Allow.Mailing.allow) && <Route exact path="/mailing/list/" component={MailingList} />}
            {view?.allow?.includes(Allow.Mailing.allow) && <Route exact path="/mailing/view/:id/general" component={MailingView} />}

            {/* Джекпоты */}
            {view?.allow?.includes(Allow.Jackpot.allow) && <Route exact path="/jackpot/list" component={JackpotList} />}

            {/* Кредитная история */}
            {view?.allow?.includes(Allow.HistoryReplenishment.allow) && <Route exact path="/credit/history" component={HistoryCredit} />}
            {view?.allow?.includes(Allow.CreditLine.allow) && <Route exact path="/credit/line" component={Line} />}

            {/* Платежные системы */}
            {view?.allow?.includes(Allow.PaymentSystem.allow) && <Route exact path="/payment/list" component={PaymentList} />}

            {/* Вывод */}
            {view?.allow?.includes(Allow.Withdrawals.allow) && <Route exact path="/withdrawals/unconfirmed" component={Operation} />}
            {view?.allow?.includes(Allow.Withdrawals.allow) && <Route exact path="/withdrawals/list" component={Withdrawals} />}

            {/* Игры */}
            {view?.allow?.includes(Allow.GamesSearch.allow) && <Route exact path="/games/search" component={GamesSearch} />}
            {view?.allow?.includes(Allow.ReportProvider.allow) && <Route exact path="/games/report" component={Report} />}

            {/* Пополнение */}
            {view?.allow?.includes(Allow.GamerReport.allow) && <Route exact path="/replenishment/gamer" component={Replenishment} />}
            {view?.allow?.includes(Allow.ReplenishmentReport.allow) && <Route exact path="/replenishment/payment" component={Payment} />}
            {/* Игроки */}
            {view?.allow?.includes(Allow.Gamer.allow) && <Route exact path="/gamer/list" component={Gamer} />}
            {view?.allow?.includes(Allow.Gamer.allow) && <Route exact path="/gamer/view/:id" component={GamerView} />}
            {view?.allow?.includes(Allow.Gamer.allow) && <Route exact path="/gamer/view/:id/report-games" component={ReportGames} />}
            {view?.allow?.includes(Allow.Gamer.allow) && <Route exact path="/gamer/view/:id/events" component={Events} />}
            {view?.allow?.includes(Allow.Gamer.allow) && <Route exact path="/gamer/view/:id/deposit" component={Deposit} />}
            {view?.allow?.includes(Allow.Gamer.allow) && <Route exact path="/gamer/view/:id/withdrawals" component={WithdrawalsGamer} />}
            {view?.allow?.includes(Allow.Gamer.allow) && <Route exact path="/gamer/view/:id/bonuses" component={Bonuses} />}
            {view?.allow?.includes(Allow.Gamer.allow) && <Route exact path="/gamer/view/:id/jackpot" component={Jackpot} />}
            {/* KYC */}
            {view?.allow?.includes(Allow.Kyc.allow) && <Route exact path="/kyc/list" component={KycList} />}

            {/* Касса */}
            {view?.allow?.includes(Allow.CashierUsers.allow) && <Route exact path="/cashiers/list" component={CashiersList} />}
            {view?.allow?.includes(Allow.CashierReport.allow) && <Route exact path="/cashiers/shift/list" component={ShiftList} />}
            {view?.allow?.includes(Allow.CashierGroup.allow) && <Route exact path="/cashiers/groups" component={GroupsCashiers} />}
            {view?.allow?.includes(Allow.CashierFinance.allow) && <Route exact path="/cashiers/finance" component={Finance} />}
            {view?.allow?.includes(Allow.CashierGroup.allow) && <Route exact path="/cashiers/view/:id" component={View} />}

            {/* Техническая поддержка */}
            {view?.allow?.includes(Allow.Support.allow) && <Route exact path="/support/list" component={Support} />}
            {view?.allow?.includes(Allow.Support.allow) && <Route path="/support/view/:id" component={ViewSupport} />}

            {/* Безопасность */}
            {view?.allow?.includes(Allow.SecurityAdmin.allow) && <Route exact path="/security/admin" component={Admin} />}
            {view?.allow?.includes(Allow.SecurityHistorySignin.allow) && <Route exact path="/security/history" component={AdminHistory} />}
            {view?.allow?.includes(Allow.SecurityHistoryEvent.allow) && <Route exact path="/security/event" component={HistoryEvent} />}
        </Switch>
    )
}

export default Routes;